import { render, staticRenderFns } from "./AdminLanguages.vue?vue&type=template&id=10e19d68&scoped=true&"
import script from "./AdminLanguages.vue?vue&type=script&lang=js&"
export * from "./AdminLanguages.vue?vue&type=script&lang=js&"
import style0 from "./AdminLanguages.vue?vue&type=style&index=0&id=10e19d68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e19d68",
  null
  
)

export default component.exports